interface PersonName {
  firstName: string | null;
  middleName: string | null;
  lastName: string | null;
}

export const formatPerson = (p: PersonName | null | undefined): string => {
  if (!p) return "-";
  return [p.lastName, p.firstName, p.middleName].filter(Boolean).join(" ");
};

export const formatPersonList = (list: PersonName[] | null | undefined): string => {
  if (!list?.length) return "-";
  return list.map(formatPerson).join("\n");
};
